import Location from "../config/location";
import StorageKeys from "../config/storageKeys";
import { RecentSearchListLength } from "./addressConstants";
import { OrderHistoryPages } from "./orderHistoryConstants";
import { updateAmplitudeUserProperties } from "../helpers/analyticsEvents";
import Utility from "./utility";

import Ajv from "ajv";
const ajv = new Ajv();

const tryJsonParse = (value, defaultValue = {}) => {
  let data;
  if (value === null || value === "null") return defaultValue;
  try {
    data = JSON.parse(value);
  } catch (e) {
    return defaultValue;
  }
  return data;
};

const setLocalStorageValue = (key, value) =>
  localStorage.setItem(key, JSON.stringify(value));

const getAddressDetail = () => {
  try {
    return localStorage.addressDetail
      ? Utility.tryJsonParse(localStorage.getItem("addressDetail"))
      : {};
  } catch (e) {}
};
const getUserMobileNo = () => {
  return localStorage.userInfo
    ? tryJsonParse(localStorage.userInfo)?.userData?.mobile
    : "";
};

const getMobileNumber = () => {
  // this method gives mobile no of user if logged in and of guest user if added by guest user in address details
  try {
    if (
      getUserData()?.userData !== undefined &&
      getUserData()?.userData?.mobile
    ) {
      return Number(getUserData()?.userData?.mobile);
    } else if (getAddressDetail()?.mobNo) {
      return Number(getAddressDetail()?.mobNo);
    } else if (localStorage.mobileNo) {
      return Number(Utility.tryJsonParse(localStorage.getItem("mobileNo")));
    } else {
      return "";
    }
  } catch (e) {}
};

const setAddressDetail = (userInfo) => {
  const addressDetail = {
    lName: userInfo?.lastName || "",
    fName: userInfo?.firstName || "",
    mobNo: getMobileNumber(),
    email: userInfo?.email ? userInfo.email : "",
    address: tryJsonParse(localStorage?.selectedAddress)?.formatted_address,
    houseNo: tryJsonParse(localStorage?.selectedAddress)?.building_number,
  };
  setLocalStorageValue("addressDetail", addressDetail);
};

const getUserId = () => {
  return localStorage.userInfo
    ? tryJsonParse(localStorage.userInfo)?.headers?.userId
    : "";
};

const getSelectedOfferIndex = () => {
  return sessionStorage.selectedOfferIndex
    ? tryJsonParse(sessionStorage.selectedOfferIndex)
    : "";
};

const setSelectedOfferIndex = (payload) => {
  sessionStorage.selectedOfferIndex = JSON.stringify(payload);
};

const isLoggedIn = () => {
  return localStorage.userInfo
    ? tryJsonParse(localStorage.userInfo)?.headers?.isLoggedIn
    : "";
};

const getUserData = () => {
  return localStorage.userInfo ? tryJsonParse(localStorage.userInfo) : {};
};

const setUserInfoData = (payload) => {
  setLocalStorageValue("userInfo", payload);
};

const setComputedLocationData = (payload) => {
  sessionStorage.computedLocationData = JSON.stringify(payload);
};

const getComputedLocationData = () => {
  return sessionStorage.computedLocationData
    ? tryJsonParse(sessionStorage.computedLocationData)
    : {};
};

const setLoadDataCart = (payload) => {
  sessionStorage.loadDataCart = JSON.stringify(payload);
};

const setOrderId = (payload) => {
  sessionStorage.orderId = JSON.stringify(payload);
};

const getLoadDataCart = () => {
  return sessionStorage.loadDataCart
    ? tryJsonParse(sessionStorage.loadDataCart)
    : {};
};

const getOrderId = () => {
  return sessionStorage.orderId ? tryJsonParse(sessionStorage.orderId) : "";
};

const unsetSessionStorageKey = (key) => {
  sessionStorage.removeItem(key);
};

const updateIsLoggedIn = (payload) => {
  let value = localStorage.userInfo ? tryJsonParse(localStorage.userInfo) : "";
  try {
    if (value?.headers) {
      value.headers.isLoggedIn = payload.isLoggedIn;
    }
    localStorage.userInfo = JSON.stringify(value);
  } catch (e) {}
};

const getIsLocationPermisssionGiven = () => {
  return localStorage.isLocationPermissionGiven
    ? tryJsonParse(localStorage.isLocationPermissionGiven)
    : false;
};

const setDeliveryTypeStationData = (value) => {
  localStorage.deliveryTypeStationData = JSON.stringify(value);
};

const getPaymentOfferMode = () => {
  if (
    localStorage.paymentMode &&
    localStorage.getItem("paymentMode") !== "null" &&
    Object.keys(Utility.tryJsonParse(localStorage.paymentMode)).length > 0
  ) {
    return Utility.tryJsonParse(localStorage.paymentMode);
  } else {
    return "";
  }
};

const isHamburger = () => {
  return localStorage.isHamburger
    ? tryJsonParse(localStorage.isHamburger)
    : false;
};

const setIsHamburger = (value) => {
  localStorage.isHamburger = value;
};

const setSelectedListUpSellItems = (value) => {
  localStorage.selectedListUpSellItems = JSON.stringify(value);
};

const getSelectedListUpSellItems = () => {
  return localStorage.selectedListUpSellItems
    ? tryJsonParse(localStorage.selectedListUpSellItems)
    : {};
};

const getDeliveryTypeStationData = () => {
  return localStorage.deliveryTypeStationData
    ? tryJsonParse(localStorage.deliveryTypeStationData)
    : {};
};

const setIsLocationPermissionGiven = () => {
  localStorage.isLocationPermissionGiven = JSON.stringify(true);
};

const setAskLocationLaterInSession = (payload = true) => {
  sessionStorage.askLocationLater = JSON.stringify(payload);
};

const getDeliveryType = () => {
  let value = localStorage.userInfo ? tryJsonParse(localStorage.userInfo) : "";
  return value?.headers?.deliveryType || "D";
};

const setDeliveryType = (payload) => {
  let value = localStorage.userInfo ? tryJsonParse(localStorage.userInfo) : "";
  try {
    if (value?.headers) {
      value.headers.deliveryType = payload;
    }
    localStorage.userInfo = JSON.stringify(value);
  } catch (e) {}
};

const getSelectedDeliveryType = () => {
  let value = localStorage.selectedDeliveryType;
  return value || "";
};

const setSelectedDeliveryType = (payload) => {
  try {
    localStorage.selectedDeliveryType = payload ? payload : "D";
  } catch (e) {}
};

const getAskLocationLaterFromSession = () => {
  return sessionStorage.askLocationLater
    ? tryJsonParse(sessionStorage.askLocationLater)
    : false;
};

const getLastLocationNew = () => {
  let _ = Utility.tryJsonParse(localStorage.lastLocationNew);
  if (Object.keys(_).length > 0) return _;
  return [];
};

const updateStoreId = (payload) => {
  let value = getLastLocationNewOrLastLocationNewForIp();
  try {
    if (Utility.isNoRedirectTrue()) {
      let storeId = Utility.getStoreIdFromUrl();
      if (storeId.length > 0) {
        localStorage.storeId = storeId;
      }
    } else {
      if (value[0]?.recent?.id) {
        localStorage.storeId = value[0].recent.id;
        sessionStorage.previousStoreId = value[0].recent.id;
        value[0].recent.id = payload.toString();
        localStorage.storeId = value[0].recent.id;
        sessionStorage.previousStoreId = value[0].recent.id;
      }
      if (getLocationSource() == "ip") {
        localStorage.lastLocationNewForIp = JSON.stringify(value);
      } else if (localStorage.lastLocationNew) {
        localStorage.lastLocationNew = JSON.stringify(value);
      }
    }
  } catch (e) {
    console.log(e);
  }
};

const updateLastLocation = (payload) => {
  let lastlocationNewKeyName =
    payload.source == "ip" ? "lastLocationNewForIp" : "lastLocationNew";
  let value = tryJsonParse(localStorage[lastlocationNewKeyName]);
  try {
    if (value[0]) {
      value[0] = payload;
    } else {
      value = [payload];
    }
    localStorage[lastlocationNewKeyName] = JSON.stringify(value);
    if (lastlocationNewKeyName == "lastLocationNewForIp") {
      localStorage.removeItem("lastLocationNew");
    }
    if (payload?.recent?.id && !Utility.isNoRedirectTrue()) {
      localStorage.storeId = payload.recent.id;
    }
  } catch (e) {
  } finally {
    const { coords = {} } = getCoordsFromRecentLocation() || {};
    updateAmplitudeUserProperties({
      latitude: coords?.latitude,
      longitude: coords?.longitude,
      pincode: payload?.recent?.addressComponent?.postalCode,
    });
  }
};

const updateLastLocationOnConfirmedLocation = () => {
  localStorage.lastLocationNewForIp = localStorage.lastLocationNew;
};

const getLocationSource = () => {
  return getLastLocationNewOrLastLocationNewForIp()[0]?.source || "";
};

const setIsTrueLocationDetected = (payload) => {
  sessionStorage.isTrueLocationDetected = JSON.stringify(payload);
};

const getIsTrueLocationDetected = () => {
  return sessionStorage.isTrueLocationDetected
    ? tryJsonParse(sessionStorage.isTrueLocationDetected)
    : false;
};

const setIsStoreIdCacheEligible = () => {
  let time = new Date().getTime() + 3 * 86400000;
  sessionStorage.isStoreIdCacheEligible = JSON.stringify(time);
};

const getIsStoreIdCacheEligible = () => {
  try {
    if (+storeId() != +getPreviousStoreId()) {
      return false;
    }
    let currentTime = new Date().getTime();
    return sessionStorage.isStoreIdCacheEligible
      ? tryJsonParse(sessionStorage.isStoreIdCacheEligible) > currentTime
      : false;
  } catch (e) {
    return false;
  }
};

const getPreviousStoreId = () => {
  return sessionStorage.previousStoreId ? sessionStorage.previousStoreId : "";
};

const setHideLocationPopupOnceInSession = () => {
  sessionStorage.hideLocationPopupOnce = JSON.stringify(true);
};

const getHideLocationPopupOnceFromSession = () => {
  return sessionStorage.hideLocationPopupOnce
    ? tryJsonParse(sessionStorage.hideLocationPopupOnce)
    : false;
};

const updateCart = (value) => {
  localStorage.setItem(StorageKeys.CARTITEMS, JSON.stringify(value));
};

const emptyCart = (value) => {
  localStorage.removeItem(StorageKeys.CARTITEMS);
};

const getCart = () => {
  let data = localStorage.cartItems
    ? tryJsonParse(localStorage[StorageKeys.CARTITEMS])
    : {};

  // const schema = {
  //   type: "object",
  // };

  // if (!ajv.validate(schema, data)) {
  //   data = {};
  //   updateCart(data);
  // }

  return data;
};

const setSessionStorageKey = (key, value = {}) => {
  if (!key) return;
  sessionStorage[key] = JSON.stringify(value);
};

const nearestApiTopAddress = () => {
  return sessionStorage.nearestApiTopAddress
    ? JSON.parse(sessionStorage.nearestApiTopAddress)
    : "";
};

const setNearestApiTopAddress = (payload) => {
  sessionStorage.nearestApiTopAddress = payload ? JSON.stringify(payload) : "";
};

const getSessionStorageKey = (key, defaultValue = {}) => {
  return sessionStorage[key] ? tryJsonParse(sessionStorage[key]) : defaultValue;
};

const getLastLocationNewOrLastLocationNewForIp = () => {
  let lastlocation = tryJsonParse(localStorage.lastLocationNew);
  if (Object.keys(lastlocation).length > 0) return lastlocation;
  lastlocation = tryJsonParse(localStorage.lastLocationNewForIp);
  if (Object.keys(lastlocation).length > 0) return lastlocation;
  return [];
};

const cartId = () => {
  return localStorage.userInfo
    ? tryJsonParse(localStorage.userInfo)?.headers?.cartId
    : "";
};

const setCartId = (payload) => {
  let value = localStorage.userInfo ? tryJsonParse(localStorage.userInfo) : "";
  try {
    if (value?.headers) {
      value.headers.cartId = payload;
    }
    localStorage.userInfo = JSON.stringify(value);
  } catch (e) {}
};
const getTip = () => {
  return localStorage.tip ? tryJsonParse(localStorage.tip) : {};
};

const getOrderType = () => {
  return localStorage.userInfo
    ? Utility.tryJsonParse(localStorage.userInfo)?.headers?.deliveryType
    : "D";
};

const setTip = (value) => {
  localStorage.tip = JSON.stringify(value);
};

const setTipAutomaticallySelected = (value) => {
  sessionStorage.TIP_CHECKBOX_VALUE = JSON.stringify(value);
  setTip({ ...getTip(), autoApply: value });
};

const getTipAutomaticallySelected = () => {
  return sessionStorage.TIP_CHECKBOX_VALUE
    ? tryJsonParse(sessionStorage.TIP_CHECKBOX_VALUE)
    : false;
};
const accessToken = () => {
  return localStorage.userInfo
    ? tryJsonParse(localStorage.userInfo)?.headers?.credentials?.accessToken ||
        tryJsonParse(localStorage.userInfo)?.headers?.credentials?.accessKeyId
    : false;
};

const storeId = () => {
  if (Utility.isNoRedirectTrue() && localStorage.storeId?.length > 0) {
    return localStorage.storeId;
  } else {
    if (getDeliveryType() != "D") {
      return sessionStorage.takeawayLocation?.storeId || getStoreId();
    }
    let value =
      getLastLocationNewOrLastLocationNewForIp()[0]?.recent?.id || getStoreId();
    if (!value) {
      value = Location.defaultStoreId;
    }
    return value;
  }
};

const getStoreId = () => {
  try {
    return localStorage.storeId
      ? localStorage.storeId
      : Location.defaultStoreId;
  } catch (e) {}
};

const getCouponCode = () => {
  return tryJsonParse(localStorage.getItem("couponCode"));
};

const setPrevUrl = (value) => {
  localStorage.setItem("prevPageUrl", JSON.stringify(value));
};

const getPrevUrl = () => {
  return tryJsonParse(localStorage.getItem("prevPageUrl"), "");
};

const getOptedDeliveryInstructions = () => {
  return tryJsonParse(localStorage.getItem("optedDeliveryInstructions"), []);
};

const setGetOfferSuccess = (val) => {
  return (sessionStorage.welcomeOfferGetStatus = JSON.stringify(val));
};

const getGetOfferSuccess = () => {
  return (
    sessionStorage?.welcomeOfferGetStatus !== undefined &&
    tryJsonParse(sessionStorage.welcomeOfferGetStatus)
  );
};

const updateCouponCode = (payload) => {
  try {
    if (payload) {
      localStorage.couponCode = JSON.stringify({ code: payload });
    } else {
      delete localStorage.couponCode;
    }
  } catch (e) {}
};

const setDiscountAllocationError = (payload) => {
  sessionStorage.setItem("discountAllocationError", payload);
};

const getDiscountAllocationError = () => {
  return sessionStorage.discountAllocationError
    ? tryJsonParse(sessionStorage.discountAllocationError)
    : false;
};

const setOfferAppliedModal = (payload) => {
  sessionStorage.setItem("offerAppliedModal", payload);
};

const getOfferAppliedModal = () => {
  return sessionStorage.getItem("offerAppliedModal");
};
const getCoordsFromRecentLocation = () => {
  let value = getLastLocationNewOrLastLocationNewForIp()[0];
  if (value?.location?.latitude) {
    value = {
      coords: {
        latitude: value.location.latitude,
        longitude: value.location.longitude,
      },
      storeId: value.recent?.id,
    };
  } else if (value?.recent?.addressComponent?.latitude) {
    value = {
      coords: {
        latitude: value.recent.addressComponent.latitude,
        longitude: value.recent.addressComponent.longitude,
      },
      storeId: value.recent?.id,
    };
  } else if (value?.recent?.latitude) {
    value = {
      coords: {
        latitude: value.recent.latitude,
        longitude: value.recent.longitude,
      },
      storeId: value.recent?.id,
    };
  }
  return value;
};

const getCoordsForTakeaway = () => {
  let takeawayLocation = sessionStorage.takeawayLocation
    ? tryJsonParse(sessionStorage.takeawayLocation)
    : "";
  if (takeawayLocation?.latitude) {
    return {
      coords: {
        latitude: takeawayLocation.latitude,
        longitude: takeawayLocation.longitude,
      },
    };
  } else {
    return "";
  }
};

const unsetKey = (key) => {
  localStorage.removeItem(key);
};

const getReturnedFromMapScreen = () => {
  return localStorage.returnedFromMapScreen
    ? tryJsonParse(localStorage.returnedFromMapScreen)
    : false;
};

const setReturnedFromMapScreen = () => {
  localStorage.returnedFromMapScreen = JSON.stringify(true);
};

const setNoDeliveryZoneInSession = (value) => {
  sessionStorage.noDeliveryLocation = JSON.stringify(value);
  return;
};

const isStoreUrlCacheEligible = () => {
  let locationData = getComputedLocationData();
  if (!locationData?.address_alias) {
    return false;
  }
  return (
    getIsStoreIdCacheEligible() &&
    window.location.href.includes(getCurrentStoreFolder() + storeId())
  );
};

const getCurrentStoreFolder = () => {
  let _ = window._siteProps_?.link_rewrite;
  if (_ == "/") {
    _ = "";
  }
  return `/${_ || "store"}/`;
};

const getAddressAlias = (
  stores,
  coords = getLastLocationNewOrLastLocationNewForIp()[0]?.location || ""
) => {
  let footerAddress =
    getLastLocationNewOrLastLocationNewForIp()[0]?.recent?.footerAddress ||
    getLastLocationNewOrLastLocationNewForIp()[0]?.recent?.city ||
    "";
  if (getLocationSource() == "ip") {
    return (
      getLastLocationNewOrLastLocationNewForIp()[0]?.recent?.city ||
      stores?.city ||
      ""
    );
  }
  let deliveryType = getDeliveryType();
  if (deliveryType == "D") {
    if (!getLastLocationNewOrLastLocationNewForIp()[0]) {
      return stores?.city || stores?.footerAddress || "";
    }
    let userAddresses = localStorage.userAddresses
      ? tryJsonParse(localStorage.userAddresses)
      : "";
    try {
      for (const item of userAddresses) {
        if (
          item.longitude == coords.longitude &&
          item.latitude == coords.latitude
        ) {
          return item.customer_address_name || item.footerAddress || item.city;
        }
      }
    } catch (err) {}
    return footerAddress;
  }
};

const calculateIsTrueLocationDetectedFromLocationSource = () => {
  return getLocationSource() == "ip" ? false : true;
};

const setAddAddressEnable = () => {
  localStorage.addAddressEnable = JSON.stringify(true);
  // localStorage.setItem("addAddressEnable", true);
};

const updateCartData = (data) => {
  localStorage.cartData = JSON.stringify(data);
};

const setOrderFailed = (data) => {
  localStorage.isOrderFailed = JSON.stringify(data);
};

const getOrderFailed = () => {
  return tryJsonParse(localStorage.isOrderFailed, false);
};
const getCartData = () => {
  return tryJsonParse(localStorage.cartData, {});
};

const setEditAddresEnable = (address) => {
  localStorage.editAddress = JSON.stringify(address);
  // localStorage.setItem("editAddress", address);
};

const getOrderTransactionId = () => {
  try {
    return localStorage.transactionId
      ? localStorage.getItem("transactionId")
      : "";
  } catch (e) {}
};

const getAddAddressEnable = () => {
  return tryJsonParse(localStorage.addAddressEnable, false);
};

const getEditAddress = () => {
  return tryJsonParse(localStorage.editAddress, {});
};

const getRecentSearchedLocationList = () => {
  return localStorage.recentSearchedLocationList
    ? tryJsonParse(localStorage.recentSearchedLocationList)
    : [];
};

const clearRecentSearchedLocationList = () => {
  localStorage.recentSearchedLocationList = JSON.stringify([]);
};
const getSelectedUserAddress = () => {
  return tryJsonParse(localStorage.selectedAddress, false);
};

const updateRecentSearchedLocationList = (item) => {
  let recentSearchedLocationList = localStorage.recentSearchedLocationList
    ? tryJsonParse(localStorage.recentSearchedLocationList)
    : [];
  recentSearchedLocationList = recentSearchedLocationList.filter(
    (element) => element.placeId !== item.placeId
  );
  recentSearchedLocationList.splice(0, 0, item);

  if (recentSearchedLocationList.length > RecentSearchListLength) {
    recentSearchedLocationList = recentSearchedLocationList.slice(
      0,
      RecentSearchListLength
    );
  }
  localStorage.recentSearchedLocationList = JSON.stringify(
    recentSearchedLocationList
  );
};

const getShowManualLocationScreen = () => {
  return localStorage.showManualLocation
    ? tryJsonParse(localStorage.showManualLocation)
    : false;
};

const setShowManualLocationScreen = (value) => {
  localStorage.showManualLocation = JSON.stringify(value);
};

const setAdvanceOrderTimeStampKey = (datetime) => {
  const { date, time } = datetime;
  const [hours, minutes] = time.match(/\d+/g);
  const isPM = time.includes("PM");
  const timeHours = parseInt(hours, 10) + (isPM && hours != 12 ? 12 : 0);

  const currentDate = new Date();
  if (date.toLowerCase() === "today") {
  } else if (date.toLowerCase() === "tomorrow") {
    currentDate.setDate(currentDate.getDate() + 1);
  } else {
    const [day, month] = date.split(" ");
    const monthIndex = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ].indexOf(month);
    currentDate.setDate(parseInt(day, 10));
    currentDate.setMonth(monthIndex);
  }

  currentDate.setHours(timeHours, parseInt(minutes, 10), 0, 0);

  const datetimestamp = Math.floor(currentDate.getTime() / 1000);
  localStorage.setItem("advanceTime", JSON.stringify(datetime));
  localStorage.setItem("advancedTime", JSON.stringify(datetimestamp));
};

const deleteAdvanceOrderTimeStampKey = () => {
  delete localStorage.advanceTime; //advanceTime - used in UI display
  delete localStorage.advancedTime; //advancedTime - dateTimestamp format for api payload
};

const getAdvanceOrderTimestamp = () => {
  try {
    return localStorage.advanceTime
      ? tryJsonParse(localStorage.advanceTime)
      : "";
  } catch (e) {}
};

const addToFavouriteIds = (payload) => {
  let favouriteIds = sessionStorage.guestFavIds
    ? tryJsonParse(sessionStorage.guestFavIds)
    : [];
  if (!favouriteIds.length) {
    favouriteIds = [payload];
  } else if (favouriteIds?.filter((i) => i.skuId == payload.skuId).length) {
  } else {
    favouriteIds = [...favouriteIds, payload];
  }
  setSessionStorageKey("guestFavIds", favouriteIds);
};

const removeFromFavouriteIds = (payload) => {
  let favouriteIds = sessionStorage.guestFavIds
    ? tryJsonParse(sessionStorage.guestFavIds)
    : [];
  if (favouriteIds.length) {
    favouriteIds = favouriteIds.filter((i) => i.skuId != payload.skuId);
    setSessionStorageKey("guestFavIds", favouriteIds);
  }
};

const getFavouriteIds = () => {
  let favIds = [];
  let favouriteIds = sessionStorage.guestFavIds
    ? tryJsonParse(sessionStorage.guestFavIds)
    : [];
  if (favouriteIds && favouriteIds?.length) {
    favouriteIds.map((i) => favIds.push(i.skuId));
  }

  return favIds;
};

const selectDeliveryInstructions = (payload) => {
  let instructions = localStorage.getItem("optedDeliveryInstructions");
  if (JSON.parse(instructions) && !JSON.parse(instructions).includes(payload)) {
    instructions = [...JSON.parse(instructions), payload];
    localStorage.setItem(
      "optedDeliveryInstructions",
      JSON.stringify(instructions)
    );
  } else {
    localStorage.setItem(
      "optedDeliveryInstructions",
      JSON.stringify([payload])
    );
  }
};

const deSelectDeliveryInstructions = (payload) => {
  let instructions = JSON.parse(
    localStorage.getItem("optedDeliveryInstructions")
  );
  if (instructions && instructions.includes(payload)) {
    instructions = [...instructions.filter((i) => i != payload)];
    localStorage.setItem(
      "optedDeliveryInstructions",
      JSON.stringify(instructions)
    );
  }
};

const getDeliveryInstructions = () => {
  let instructions = JSON.parse(
    localStorage.getItem("optedDeliveryInstructions")
  );
  let deliveryInstruction = "";
  if (instructions && instructions?.length) {
    instructions.map((x) => {
      if (x.toLowerCase() == "directions to reach") {
        let dirnToReach = JSON.parse(localStorage.getItem("directionsToReach"))
          ? JSON.parse(localStorage.getItem("directionsToReach"))
          : "";
        deliveryInstruction = deliveryInstruction
          ? deliveryInstruction + " | " + dirnToReach
          : dirnToReach;
      } else {
        deliveryInstruction = deliveryInstruction
          ? deliveryInstruction + " | " + x
          : x;
      }
    });
  }

  localStorage.setItem("deliveryInstructions", deliveryInstruction);
  return deliveryInstruction;
};

const getOrderHistoryPage = () => {
  return localStorage.orderHistoryPage
    ? tryJsonParse(localStorage.orderHistoryPage)
    : OrderHistoryPages.MY_ORDERS;
};

const setOrderHistoryPage = (value) => {
  localStorage.orderHistoryPage = JSON.stringify(value);
};

const setDirectionsToReach = (value) => {
  localStorage.directionsToReach = JSON.stringify(value);
};

const getDirectionsToReach = () => {
  return localStorage.directionsToReach
    ? tryJsonParse(localStorage.directionsToReach)
    : "";
};
const setOrderSummary = (value) => {
  localStorage.orderSummary = JSON.stringify(value);
};

const getOrderSummary = () => {
  return localStorage.orderSummary
    ? tryJsonParse(localStorage.orderSummary)
    : "";
};

const setCurrentGPSLocation = (value) => {
  sessionStorage.currentGPSLocation = JSON.stringify(value);
};

const getCurrentGPSLocation = () => {
  return tryJsonParse(sessionStorage.currentGPSLocation, {});
};

const getLocationChangedAddress = () => {
  return localStorage.locationChangedAddress
    ? tryJsonParse(localStorage.locationChangedAddress)
    : "";
};

const deleteLocationChangedAddress = () => {
  delete localStorage.locationChangedAddress;
};

const setLocationChangeAddress = () => {
  localStorage.locationChangedAddress = true;
};

const getSelectedStore = () => {
  return tryJsonParse(localStorage.selectedStoreData, false);
};

const setSelectedStore = (value) => {
  localStorage.selectedStoreData = JSON.stringify(value);
};

const resetAllSelectedLocations = () => {
  setSelectedStore(false);
  setLocalStorageValue("selectedAddress", false);
  setDeliveryTypeStationData({});
};
const setUserAddresses = (payload) => {
  localStorage.userAddresses = JSON.stringify(payload);
};

const getTipAmount = () => {
  return localStorage.tip ? Number(tryJsonParse(localStorage.tip).amount) : 0;
};

const getReorderedItems = () => {
  return localStorage.reorderedItems
    ? tryJsonParse(localStorage.reorderedItems)
    : "";
};
const setReorderedItems = (value) => {
  localStorage.reorderedItems = JSON.stringify(value);
};

const getReorderItemsOrder = () => {
  return localStorage.reorderItemsOrder
    ? tryJsonParse(localStorage.reorderItemsOrder)
    : [];
};
const setReorderItemsOrder = (value) => {
  localStorage.reorderItemsOrder = JSON.stringify(value);
};

const setAnimationScroll = (value) => {
  sessionStorage.animationScroll = JSON.stringify(value);
};

const getAnimationScroll = () => {
  return sessionStorage.animationScroll
    ? tryJsonParse(sessionStorage.animationScroll)
    : true;
};
const setShowMyAddressModalOnCart = () => {
  localStorage.showMyAddressModalOnCart = true;
};
const deleteShowMyAddressModalOnCart = () => {
  delete localStorage.showMyAddressModalOnCart;
};
const getSelectedChangedLocationForTwyDinein = () => {
  return tryJsonParse(localStorage.selectedChangedLocationForTwyDinein);
};
const setSelectedChangedLocationForTwyDinein = (payload) => {
  localStorage.selectedChangedLocationForTwyDinein = JSON.stringify(payload);
};

export default {
  setLocalStorageValue,
  cartId,
  setCartId,
  accessToken,
  getUserMobileNo,
  isLoggedIn,
  getUserData,
  setComputedLocationData,
  getComputedLocationData,
  getLastLocationNewOrLastLocationNewForIp,
  unsetSessionStorageKey,
  updateIsLoggedIn,
  getIsLocationPermisssionGiven,
  setIsLocationPermissionGiven,
  setAskLocationLaterInSession,
  getCoordsFromRecentLocation,
  getDeliveryType,
  setDeliveryType,
  getSelectedDeliveryType,
  setSelectedDeliveryType,
  getAskLocationLaterFromSession,
  updateStoreId,
  updateLastLocation,
  updateLastLocationOnConfirmedLocation,
  getLocationSource,
  updateCart,
  emptyCart,
  getCart,
  setIsTrueLocationDetected,
  getIsTrueLocationDetected,
  getIsStoreIdCacheEligible,
  setIsStoreIdCacheEligible,
  setHideLocationPopupOnceInSession,
  getHideLocationPopupOnceFromSession,
  setSessionStorageKey,
  getSessionStorageKey,
  getIsLocationPermisssionGiven,
  getCouponCode,
  setGetOfferSuccess,
  getGetOfferSuccess,
  getLastLocationNewOrLastLocationNewForIp,
  storeId,
  updateCouponCode,
  getCoordsForTakeaway,
  unsetKey,
  getReturnedFromMapScreen,
  setReturnedFromMapScreen,
  setNoDeliveryZoneInSession,
  isStoreUrlCacheEligible,
  getAddressAlias,
  calculateIsTrueLocationDetectedFromLocationSource,
  setAddAddressEnable,
  setEditAddresEnable,
  getAddAddressEnable,
  getEditAddress,
  getUserId,
  getRecentSearchedLocationList,
  clearRecentSearchedLocationList,
  updateRecentSearchedLocationList,
  setShowManualLocationScreen,
  getShowManualLocationScreen,
  getSelectedUserAddress,
  addToFavouriteIds,
  removeFromFavouriteIds,
  getOrderHistoryPage,
  setOrderHistoryPage,
  selectDeliveryInstructions,
  deSelectDeliveryInstructions,
  setDirectionsToReach,
  setOrderSummary,
  getOrderSummary,
  getOrderId,
  setOrderId,
  setCurrentGPSLocation,
  getCurrentGPSLocation,
  setOfferAppliedModal,
  getOfferAppliedModal,
  setPrevUrl,
  getPrevUrl,
  getOptedDeliveryInstructions,
  getLocationChangedAddress,
  deleteLocationChangedAddress,
  setLocationChangeAddress,
  getSelectedStore,
  setSelectedStore,
  resetAllSelectedLocations,
  setTip,
  getTip,
  setLoadDataCart,
  getLoadDataCart,
  setUserAddresses,
  getDeliveryInstructions,
  getDirectionsToReach,
  setAdvanceOrderTimeStampKey,
  deleteAdvanceOrderTimeStampKey,
  getFavouriteIds,
  setAddressDetail,
  setTipAutomaticallySelected,
  updateCartData,
  getCartData,
  getOrderTransactionId,
  getAdvanceOrderTimestamp,
  getTipAmount,
  setDeliveryTypeStationData,
  getDeliveryTypeStationData,
  getReorderedItems,
  setReorderedItems,
  getReorderItemsOrder,
  setReorderItemsOrder,
  getOrderType,
  getAddressDetail,
  nearestApiTopAddress,
  setNearestApiTopAddress,
  getMobileNumber,
  setOrderFailed,
  getSelectedOfferIndex,
  setSelectedOfferIndex,
  getOrderFailed,
  getLastLocationNew,
  setShowMyAddressModalOnCart,
  deleteShowMyAddressModalOnCart,
  getTipAutomaticallySelected,
  setSelectedListUpSellItems,
  getSelectedListUpSellItems,
  setUserInfoData,
  isHamburger,
  setIsHamburger,
  setDiscountAllocationError,
  getDiscountAllocationError,
  setAnimationScroll,
  getAnimationScroll,
  getPaymentOfferMode,
  getSelectedChangedLocationForTwyDinein,
  setSelectedChangedLocationForTwyDinein,
};
